import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2Icon } from 'lucide-react';
export function ServicesSection() {
  const services = ["Alzheimer's/Dementia", 'Bathing/Dressing', 'Companion Care', 'Doctor Visits', 'Errands/Shopping', 'Help with Eating', 'Housekeeping', 'Incontinence Care', 'Laundry', 'Light Exercise', 'Live-In Care', 'Meal Preparation', 'Medication Reminders', 'Mobility Assistance', 'Oral Hygiene', 'Personal Care', 'Physical Therapy', 'Respite Care', 'Skilled Nursing', 'Socialization/Emotional Support', 'Toileting', 'Transfer Assistance', 'Transportation'];
  return <section id="services" className="py-24 px-4 bg-warm" data-id="element-205">
      <div className="max-w-7xl mx-auto" data-id="element-206">
        <div className="text-center max-w-3xl mx-auto mb-16" data-id="element-207">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-3xl md:text-4xl font-heading font-bold text-neutral-dark mb-4" data-id="element-208">
            Our Services
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-lg text-neutral-medium" data-id="element-209">
            Comprehensive home health services tailored to your family's needs —
            all provided in the comfort of home.
          </motion.p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="bg-white p-8 md:p-12 rounded-3xl shadow-sm border border-gray-100" data-id="element-210">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-y-6 gap-x-8" data-id="element-211">
            {services.map((service, index) => <div key={index} className="flex items-start gap-3" data-id="element-212">
                <CheckCircle2Icon className="w-5 h-5 text-accent flex-shrink-0 mt-0.5" data-id="element-213" />
                <span className="text-neutral-dark font-medium" data-id="element-214">{service}</span>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}